<template>
    <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M15.6967 12.5238H4.30318C3.50983 12.5238 2.8667 13.1026 2.8667 13.8166V13.8176C2.8667 14.5317 3.50983 15.1105 4.30318 15.1105H15.6967C16.4901 15.1105 17.1332 14.5317 17.1332 13.8176V13.8166C17.1332 13.1026 16.4901 12.5238 15.6967 12.5238Z"
            stroke="#585F66"
            stroke-width="1.5"
            stroke-miterlimit="10"
        />
        <path
            d="M15.6967 9.93713H4.30318C3.50983 9.93713 2.8667 10.516 2.8667 11.23V11.231C2.8667 11.945 3.50983 12.5238 4.30318 12.5238H15.6967C16.4901 12.5238 17.1332 11.945 17.1332 11.231V11.23C17.1332 10.516 16.4901 9.93713 15.6967 9.93713Z"
            stroke="#585F66"
            stroke-width="1.5"
            stroke-miterlimit="10"
        />
        <path
            d="M15.6967 7.35034H4.30318C3.50983 7.35034 2.8667 7.92916 2.8667 8.64317V8.64419C2.8667 9.3582 3.50983 9.93702 4.30318 9.93702H15.6967C16.4901 9.93702 17.1332 9.3582 17.1332 8.64419V8.64317C17.1332 7.92916 16.4901 7.35034 15.6967 7.35034Z"
            stroke="#585F66"
            stroke-width="1.5"
            stroke-miterlimit="10"
        />
        <path d="M13.1524 4.76477H6.84863" stroke="#585F66" stroke-width="1.5" stroke-miterlimit="10" />
        <path
            d="M8.39249 9.08337H11.6076C11.995 9.08337 12.3089 9.36593 12.3089 9.71454V14.9997H7.69006V9.71454C7.69006 9.36593 8.00401 9.08337 8.39136 9.08337H8.39249Z"
            fill="#585F66"
        />
        <path
            d="M1.39526 9.44617L9.16827 2.45046C9.60531 2.05712 10.3134 2.05712 10.7493 2.45046L18.6047 9.52036"
            stroke="#585F66"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
        />
        <path d="M17.1953 3.15076V8.20519" stroke="#585F66" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" />
    </svg>
</template>

<script>
export default {
    name: 'AccommodationIcon',
    props: {},
    data() {
        return {}
    }
}
</script>
